'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseWorkflow', ['$scope', '$rootScope', '$state', 'ProcessEnterprises', 'ProcessLicenses', '$stateParams', '$q', function ($scope, $rootScope, $state, ProcessEnterprises, ProcessLicenses, $stateParams, $q) {
        $scope.resetLicense();
        $scope.initial = true;
        $scope.saving = false;
        $scope.editMode = false;
        $scope.loading = true;

        var processEnterpriseProm = ProcessEnterprises.get().then(function (process_enterprises) {
            $scope.process_enterprises = process_enterprises;
        })

        var processLicenseProm = ProcessLicenses.get($stateParams.id).then(function (process_licenses) {
            $scope.process_licenses = process_licenses;
        })

        $q.all([processEnterpriseProm, processLicenseProm]).then(function () {
            $scope.setupProcesses();
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.setupProcesses = function () {
            $scope.processes = [];
            $scope.process_enterprises.forEach(function (processEnterprise) {
                if (processEnterprise.process != null) {
                    var process = {};
                    process.process_statuses = [];
                    process.process_id = processEnterprise.process.id;
                    process.process_name = processEnterprise.process.name;
                    process.sort_order = processEnterprise.process.sort_order;

                    var found = false;
                    $scope.process_licenses.forEach(function (process_license) {
                        if (!found) {
                            if (process_license.process_id == process.process_id) {
                                // Set up to be converted to Process_Licenses
                                process.id = process_license.id;
                                process.active = true;
                                //////////
                                found = true;
                                processEnterprise.process.process_statuses.forEach(function (process_status) {
                                    var statusFound = false;
                                    process_license.process_statuses.forEach(function (ps) {
                                        if (!statusFound) {
                                            process_status.active = false;
                                            if (ps.id == process_status.id) {
                                                process_status.active = true;
                                                statusFound = true;
                                            }
                                        }
                                    })
                                    process.process_statuses.push(process_status);
                                })
                            }
                        }
                    })
                    if (!found) {
                        // Set up to be converted to Process_Licenses
                        process.active = false;
                        process.id = undefined;
                        processEnterprise.process.process_statuses.forEach(function (process_status) {
                            process_status.active = false;
                            process.process_statuses.push(process_status);
                        })
                        //////////////
                    }
                    $scope.processes.push(process);
                }
            })
        }

        $scope.changeToEdit = function () {
            $scope.editMode = true;
        }

        $scope.backToShow = function () {
            $scope.editMode = false;
        }

        $scope.save = function () {
            $scope.saving = true;

            var all = [];

            $scope.processes.forEach(function (process_license) {
                if (process_license.active) {
                    process_license.license_id = $stateParams.id;
                    all.push(ProcessLicenses.save(process_license).then(function(processLicense){
                        updateArray($scope.process_licenses, processLicense);
                    }));
                }
                else {
                    if (process_license.id != null) {
                        all.push(ProcessLicenses.delete(process_license.id).then(function(){
                            updateArray($scope.process_licenses, process_license, true);
                        }));
                    }
                }
            })

            $q.all(all).then(function () {
                $scope.setupProcesses();
                $scope.saving = false;
                $scope.editMode = false;
            }).catch(function (response) {
                // handle error
            });
        }

        $scope.toggleStatuses = function (process) {
            process.process_statuses.forEach(function (process_status) {
                if (process_status.status != null && process_status.status.enterprise_id == $rootScope.enterpriseID) {
                    process_status.active = process.active;
                }
            });
        }
    }])




